const GENERAL_INFORMATION = [
    'ContractOwner',
    'Country',
    'DocumentCategory',
    'DocumentType',
    'MaterialAgreement',
    'OriginalVersionStored',
];
const LIFECYCLE_AND_STATUS = ['Active'];
const DATES = ['NoticeDate', 'ProbationaryPeriodExpirationDate', 'StartDate', 'TerminationDate'];
const COMMERCIAL = [
    'Currency',
    'Discount',
    'FeeAdjustmentClause',
    'PaymentTermsDaysFromInvoiceDate',
    'TotalContractCost',
    'TotalContractValue',
];
const RENEWAL_AND_TERMINATION = [
    'AutomaticRenewal',
    'NoticePeriodDays',
    'NoticePeriodMonths',
    'OriginalTermMonths',
    'PostTerminationObligations',
    'RenewalTermMonths',
    'TerminationForCause',
    'TerminationForConvenience',
];
const LIABILITY_AND_RISK = ['Indemnity', 'LiabilityCap', 'LiabilityCapScope', 'LimitationOfLiability'];
const HR = ['ProbationaryPeriod'];
const REGULATORY = ['DeviateFromStandard', 'GoverningLaw', 'Outsourcing', 'ProcessingOfPersonalData'];
export const PROPERTY_GROUPS = {
    GENERAL_INFORMATION,
    LIFECYCLE_AND_STATUS,
    DATES,
    COMMERCIAL,
    RENEWAL_AND_TERMINATION,
    LIABILITY_AND_RISK,
    HR,
    REGULATORY,
};
export const SUPPORTED_PROPERTIES = [
    ...GENERAL_INFORMATION,
    ...LIFECYCLE_AND_STATUS,
    ...DATES,
    ...COMMERCIAL,
    ...RENEWAL_AND_TERMINATION,
    ...LIABILITY_AND_RISK,
    ...HR,
    ...REGULATORY,
];
